import { AppSettings } from "@/AppSettings";
import { useMemo } from "react";
import { createFormConfiguration } from "./useFormConfiguration";
import { ConfigurationSourceDataMap, Metadata, Trial } from "@/api/dtos";

const useFormConfigurations = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    trial?: Trial, 
    configurationSourceDataId?: number,
    studyEventOid?: string,
    baseRoute?: string
) => {
    return useMemo(() => {
        if (!studyEventOid) {
            if (!metadata || !metadata.forms) {
                return undefined;
            }
    
            return (
                Object.keys(metadata.forms).map(caseReportFormOid => {
                    return createFormConfiguration(
                        metadata, 
                        trialConfiguration?.forms, 
                        configuration?.forms, 
                        trial, 
                        configuration?.configuration?.isGlobal,
                        configuration?.configuration?.id ?? configurationSourceDataId,  
                        studyEventOid,
                        caseReportFormOid,
                        baseRoute
                    );
                }) as Array<NonNullable<ReturnType<typeof createFormConfiguration>>>
            )
            .filter(x => !!x)
            .sort((a, b) => a.formMetadata?.name! < b.formMetadata?.name! ? -1 : 1)
        }
        else {
            if (!metadata || !metadata.eventForms || !metadata.eventForms[studyEventOid]) {
                return undefined;
            }
    
            return (
                Object.keys(metadata.eventForms[studyEventOid]).map(caseReportFormOid => {
                    return createFormConfiguration(
                        metadata, 
                        trialConfiguration?.forms, 
                        configuration?.forms, 
                        trial, 
                        configuration?.configuration?.isGlobal,
                        configuration?.configuration?.id ?? configurationSourceDataId, 
                        studyEventOid,
                        caseReportFormOid,
                        baseRoute
                    );
                }) as Array<NonNullable<ReturnType<typeof createFormConfiguration>>>
            )
            .filter(x => !!x)
            .sort((a, b) => a.eventFormMetadata?.order! < b.eventFormMetadata?.order! ? -1 : 1)
        }
    }, [metadata, trialConfiguration?.forms, configuration?.forms, trial, configurationSourceDataId, studyEventOid, baseRoute]) 
};

export default useFormConfigurations;